import React from 'react';
import { useObservable } from 'react-use-observable';

import leadsService from 'v2/services/leads/list';
import tableService from 'v2/services/table';

import Export from '../Export';

const Details = () => {
  const [totalItems] = useObservable(() => leadsService.getTotalItems(), []);
  const [loading] = useObservable(() => tableService.isLoading(), []);

  if (loading) return null;

  return (
    <div
      className='mb-2 flex w-full flex-row items-center justify-between text-center min-[600px]:mb-4 min-[600px]:w-full min-[600px]:rounded-sm min-[600px]:bg-white min-[600px]:shadow-[0_1px_0_0_rgba(0,0,0,0.07)]'
      id='leads-details'
    >
      <div>
        <span className='pl-4 font-semibold' id='leads-result-button-label' data-testid='leads-result-label'>
          {totalItems} leads
        </span>
      </div>
      <div>
        <Export />
      </div>
    </div>
  );
};

export default Details;
